import { useTranslations } from '@vocab/react';
import {
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import { ContentLoader } from 'src/app/views/shared/ContentLoader';

import translations from './.vocab';

export const RoleInformation = ({
  jobTitle,
  jobLocation,
  loading,
}: {
  jobTitle: string;
  jobLocation: string;
  loading: boolean;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Card>
      <Stack space="medium">
        <Heading level="3">{t('role-information-heading')}</Heading>
        <Divider />
        <Columns space="xxlarge">
          <Column width="1/4">
            <Text weight="strong">{t('role-information-job-title-label')}</Text>
          </Column>
          <Column>
            <ContentLoader loading={loading} lines={['50%']} offset>
              <Text>{t('role-information-job-title-text', { jobTitle })}</Text>
            </ContentLoader>
          </Column>
        </Columns>
        <Columns space="xxlarge">
          <Column width="1/4">
            <Text weight="strong">
              {t('role-information-job-location-label')}
            </Text>
          </Column>
          <Column>
            <ContentLoader loading={loading} lines={['50%']} offset>
              <Text>
                {t('role-information-job-location-text', { jobLocation })}
              </Text>
            </ContentLoader>
          </Column>
        </Columns>
      </Stack>
    </Card>
  );
};
